module.exports = __webpack_public_path__ + "img/income2.10919f5c.png";